import { Flex, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Routes } from '../../../../../../route/Routes';
import {
  bodyTextProps,
  formatPart2Date,
  NACHVERSAND_GREEN,
  Part2Appointment,
} from '../../../versand/utils';
import { Part2BookingButton } from '../../../versand/components';

export const MissedBannerContent = ({
  appointment,
}: {
  appointment: Part2Appointment;
}) => {
  const { t } = useTranslation('versand');

  return (
    <>
      <Text {...bodyTextProps}>
        {t('Missed.Description', {
          date: formatPart2Date(appointment.startTime),
        })}
      </Text>
      <Flex align="center" gap="20px" wrap="wrap">
        <Part2BookingButton label={t('Missed.Button')} />
        <Link
          to={`${Routes.Study}/${Routes.Versand}`}
          style={{ color: NACHVERSAND_GREEN, fontWeight: 500 }}
        >
          {t('Missed.ToVersand')} &rarr;
        </Link>
      </Flex>
    </>
  );
};
